/**
 * TDK 设置：从接口 https://www.marinelinkco.com/server/webSite 获取
 * title -> 页面标题 (document.title)
 * keyword -> meta keywords
 * description -> meta description
 */

// 默认兜底值（接口失败时使用）
const DEFAULT_TDK = {
  title: '環球船舶海工博覽交流網',
  keyword: '',
  description: ''
}

const TDK_API = 'https://www.marinelinkco.com/server/webSite'

// TDK 缓存，其他地方如需使用可直接 import
let tdkCache = null

/**
 * 设置或更新 <meta> 标签
 * @param {string} name meta 的 name 属性值
 * @param {string} content meta 的 content 属性值
 */
function setMeta(name, content) {
  if (!content) return
  let meta = document.querySelector(`meta[name="${name}"]`)
  if (meta) {
    meta.setAttribute('content', content)
  } else {
    meta = document.createElement('meta')
    meta.setAttribute('name', name)
    meta.setAttribute('content', content)
    document.head.appendChild(meta)
  }
}

/**
 * 将 TDK 应用到当前页面
 * @param {{title:string, keyword:string, description:string}} tdk
 */
function applyTDK(tdk) {
  if (tdk.title) {
    document.title = tdk.title
  }
  setMeta('keywords', tdk.keyword)
  setMeta('description', tdk.description)
}

/**
 * 拉取接口并设置 TDK（全站只请求一次，结果缓存）
 * @param {boolean} force 强制刷新缓存重新请求
 * @returns {Promise<{title:string, keyword:string, description:string}>}
 */
export async function initTDK(force = false) {
  if (tdkCache && !force) {
    applyTDK(tdkCache)
    return tdkCache
  }
  try {
    const res = await fetch(TDK_API)
    const json = await res.json()
    if (json && json.code === 200 && json.data) {
      tdkCache = {
        title: json.data.title || DEFAULT_TDK.title,
        keyword: json.data.keyword || DEFAULT_TDK.keyword,
        description: json.data.description || DEFAULT_TDK.description
      }
    } else {
      tdkCache = DEFAULT_TDK
    }
  } catch (e) {
    console.warn('[TDK] 接口请求失败，使用默认标题', e)
    tdkCache = DEFAULT_TDK
  }
  applyTDK(tdkCache)
  return tdkCache
}

/**
 * 获取当前缓存的 TDK（未初始化时返回默认值）
 */
export function getTDK() {
  return tdkCache || DEFAULT_TDK
}

export default { initTDK, getTDK }
